// extracted by mini-css-extract-plugin
module.exports = {"c1foi1fo":"c1foi1fo","s10t8so0":"s10t8so0","tg6ib1t":"tg6ib1t"};